"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var BaseHeading = styled_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 1em 0;\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.3;\n"], ["\n  margin: 1em 0;\n  color: ", ";\n  font-weight: ", ";\n  line-height: 1.3;\n"])), tokens_1.colors.text.default, tokens_1.fonts.weight.normal);
exports.BaseHeading = BaseHeading;
var Heading = function (props) {
    var Component = Heading.Element[props.size];
    return (React.createElement(Component, __assign({}, automation_attribute_1.default('heading'), props), props.children));
};
Heading.Element = [];
Heading.Element[1] = styled_1.default(BaseHeading.withComponent('h1'))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 36px;\n"], ["\n  font-size: 36px;\n"])));
Heading.Element[2] = styled_1.default(BaseHeading.withComponent('h2'))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 24px;\n  font-weight: ", ";\n"], ["\n  font-size: 24px;\n  font-weight: ", ";\n"])), tokens_1.fonts.weight.medium);
Heading.Element[3] = styled_1.default(BaseHeading.withComponent('h3'))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 18px; /* TO-DO: tokenize */\n  font-weight: ", ";\n"], ["\n  font-size: 18px; /* TO-DO: tokenize */\n  font-weight: ", ";\n"])), tokens_1.fonts.weight.bold);
Heading.Element[4] = styled_1.default(BaseHeading.withComponent('h4'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: ", ";\n"], ["\n  font-size: 14px;\n  font-weight: ", ";\n"])), tokens_1.fonts.weight.medium);
var StyledHeading = Heading.Element;
exports.StyledHeading = StyledHeading;
Heading.defaultProps = {
    size: 1,
    children: null
};
exports.default = Heading;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=heading.js.map